<template>
  <div id="head_portrait_select_outer">
    <div>
      <a class="close-button" href="javascript:void(0);" @click="closeButtonClicked">
        <img src="../../assets/shl_personal_setting_close.png">
      </a>

      <div class="select-content" >
        <div class="select-label">选择头像</div>
        <image-clip style="margin-top: 10px;" v-on:callback="selectImage" />
        <div v-if="tempUrl != null" style="text-align: center;margin-top: 15px;">
          <img v-if="tempUrl != null" :src="tempUrl" class="preview-image">
        </div>

        <div class="select-notice">上传头像请小于5M，比例为1：1</div>
        <input class="select-submit" type="button" value="提交" @click="submitButtonClicked">
      </div>
    </div>
  </div>
</template>

<script>
import ImageClip from "../vue-clip/ImageClip";
export default {
  name: "HeadportraitSelect",
  components: {
    ImageClip
  },
  data() {
    return {
      tempUrl: null,
      postUrl: null,
      isUploading: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {

    selectImage(imageData) {
      this.tempUrl = imageData;
    },

    closeButtonClicked() {
      // console.log('---3')
      this.$emit('close');
    },
    submitButtonClicked() {
      if (this.tempUrl != null) {
        this.uploadImage(this.tempUrl);
        return;
      }
      this.$toast('请先选择图片');
    },

    uploadImage( imageData) {
      if (this.isUploading) {
        this.$toast('正在上传头像！');
        return;
      }
      this.isUploading = true;

      if (this.postUrl == undefined || this.postUrl == undefined || this.postUrl == '') {
        let _this = this;
        this.$store.state.http.ajax.postImage(imageData, function (code, imagUrl) {
          _this.isUploading = false;
          if (code == 0) {
            _this.postUrl = imagUrl;
            _this.submitUserEdit(_this.postUrl);
          } else {
            _this.$toast('上传失败！');
          }
        });
        return;
      }
      this.submitUserEdit(_this.postUrl);
    },


    submitUserEdit(headerImageUrl) {
      if (headerImageUrl == undefined || headerImageUrl == undefined || headerImageUrl == '') {
        this.$toast('头像为空！');
        return;
      }

      let params = {
        headPortrait: headerImageUrl,
        flag: 4
      }
      // console.log(params);
      //
      let _this = this;
      this.$store.state.http.ajax.ucProfileUpdate(params, function (data) {
        // console.log(data);
        if (data.code == 0) {
          _this.$toast('上传成功');
          setTimeout(function () {
            _this.$router.go(0);
          },1000);
        } else {
          _this.$toast('上传失败');
        }
      },function (data) {
        _this.$toast('上传失败，请重试！');
      });
    }
  },
}
</script>

<style scoped>
  #head_portrait_select_outer {
    background-color: rgba(0,0,0,0.3);
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #head_portrait_select_outer > div {
    /*width: 70vw;*/
    padding-left: 30px;
    padding-right: 30px;
    min-width: 290px;
    position: relative;
    background-color: white;
    min-height: 150px;
    padding-bottom: 40px;
  }

  #head_portrait_select_outer .close-button img {
    width: 20px;
    height: auto;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 999;
  }

  #head_portrait_select_outer .select-label {
    text-align: center;
    color: #333;
    font-size: 1.5rem;
    font-weight: bold;
  }

  #head_portrait_select_outer .select-content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    margin-top: 35px;
    width: 100%;
    padding-left: 5px;
    padding-right: 5px
  }

  #head_portrait_select_outer .preview-image {
    width: 50%;
    min-width: 150px;
    max-width: 200px;
    height: auto;
  }

  #head_portrait_select_outer .select-notice {
    font-size: 12px;
    color: #999;
    margin-top: 15px;
  }

  input {
    outline: none;
  }

  #head_portrait_select_outer .select-submit {
    background-color: #fc1a34;
    border: none;
    border-radius: 20px;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    color: white;
    min-width: 150px;
    margin-top: 30px;
  }


</style>



// WEBPACK FOOTER //
// src/components/HeadportraitSelect/HeadportraitSelect.vue